import clsx from 'clsx'
import { ComponentPropsWithRef, createElement } from 'react'

const variants = {
  h1: 'h1' as 'h1',
  h2: 'h2' as 'h2',
  h3: 'h3' as 'h3',
  h4: 'h4' as 'h4',
  h5: 'h5' as 'h5',
  h6: 'h6' as 'h6',
  subtitle1: 'h6' as 'h6',
  subtitle2: 'h6' as 'h6',
  body1: 'p' as 'p',
  body2: 'p' as 'p',
  label: 'label' as 'label',
  caption: 'p' as 'p',
  helperText: 'span' as 'span',
}

const variantsClassName = {
  h1: 'text-8xl font-overpass',
  h2: 'text-7xl font-overpass',
  h3: 'text-6xl font-overpass',
  h4: 'text-5xl font-overpass',
  h5: 'text-4xl font-overpass font-bold',
  h6: 'text-3xl font-overpass',
  subtitle1: 'text-2xl font-overpass',
  subtitle2: 'text-base font-inter font-medium',
  body1: 'text-base font-inter',
  body2: 'text-sm font-inter',
  label: 'text-sm font-inter',
  caption: 'text-xs font-inter font-medium',
  helperText: 'text-xs font-inter font-medium',
}

const colorsClassName = {
  inherit: '',
  primary: 'text-primary-600 dark:text-white',
  secondary: 'text-secondary-500',
  textPrimary: 'text-black',
  textSecondary: 'text-gray-500',
  accent: 'text-white',
  success: 'text-success-900',
  error: 'text-error-500',
  warning: 'text-warning-500',
}

interface TypographyProps<Variant> {
  variant: Variant
  color?: keyof typeof colorsClassName
  noWrap?: boolean
}

function Typography<Variant extends keyof typeof variants>(
  props: TypographyProps<Variant> & ComponentPropsWithRef<(typeof variants)[Variant]>,
) {
  const { children, variant, color = 'inherit', className, noWrap, ...rest } = props

  return createElement(
    variants[variant],
    {
      className: clsx(className, 'block', variantsClassName[variant], colorsClassName[color], {
        'overflow-hidden whitespace-nowrap overflow-ellipsis': noWrap,
      }),
      ...rest,
      title: noWrap ? children : undefined,
    },
    children,
  )
}

Typography.displayName = 'Typography'
// TODO: is there a better way to do this?
//
// https://fettblog.eu/typescript-react-generic-forward-refs/
export default Typography
